export const HISTORY_RANGES = [
  {
    days: 30,
    labelClassName: 'sm:hidden',
    barClassName: 'block',
    leftEdgeTooltipClassName: 'left-0 sm:left-1/2 sm:-translate-x-1/2',
  },
  {
    days: 60,
    labelClassName: 'hidden sm:inline md:hidden',
    barClassName: 'hidden sm:block',
    leftEdgeTooltipClassName: 'left-0 md:left-1/2 md:-translate-x-1/2',
  },
  {
    days: 90,
    labelClassName: 'hidden md:inline',
    barClassName: 'hidden md:block',
    leftEdgeTooltipClassName: 'left-0',
  },
] as const
